<template>
  <VTest :default-test="defaultTest" :test-diffs="testDiffs" :component="VProgress" i18n="substore" />
</template>

<script>
import VTest from '@/components/Test';
import VProgress from '@/components/Progress';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'ProgressTest',

  components: {
    VTest,
  },

  data() {
    return {
      defaultTest,
      testDiffs,
      VProgress,
    };
  },
};
</script>
